// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  WildLeg,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  encounterId: __t.u64().name("encounter_id"),
  species: __t.u8(),
  seed: __t.u32(),
  get legs() {
    return __t.array(WildLeg);
  },
  untilMs: __t.i64().name("until_ms"),
  homeX: __t.i32().name("home_x"),
  homeY: __t.i32().name("home_y"),
  attend: __t.option(__t.u16()),
  leaving: __t.bool(),
});
